/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAssessmentQuestion } from 'app/shared/model/assessment-question.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPreAssessment } from 'app/shared/model/pre-assessment.model';

export interface IAssessmentAnswer {
  id?: string;
  answer?: boolean | null;
  comment?: string | null;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  question?: IAssessmentQuestion;
  patient?: IGlucoUser;
  preAssessment?: IPreAssessment;
}

export const defaultValue: Readonly<IAssessmentAnswer> = {
  answer: false,
  active: false,
};
